import React, { Component } from 'react'

import classes from './User.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
// import Button from '../../../../components/UI/Button/Button'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/Manage/User/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Checkbox } from '@material-ui/core'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class SetupUser extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: this.props.translate('add'),
    actionRecordId: null,
    formValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      user_name: {
        label: this.props.translate('userName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('userName'),
          autoComplete: 'user_name',
          name: 'user_name'
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      first_name: {
        label: this.props.translate('firstName'),
        elementType: 'input',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('firstName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      last_name: {
        label: this.props.translate('lastName'),
        elementType: 'input',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('lastName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      email: {
        label: this.props.translate('emailAddress'),
        elementType: 'input',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('emailAddress')
        },
        value: '',
        validation: {
          required: true,
          isEmail: true
        },
        valid: false,
        touched: false,
        error: null
      },
      password: {
        label: this.props.translate('password'),
        elementType: 'input',
        elementConfig: {
          type: 'password',
          placeholder: this.props.translate('password'),
          autoComplete: 'new-password'
        },
        value: '',
        validation: {
          required: true,
          minLength: 6
        },
        valid: false,
        touched: false,
        error: null
      },
      confirm_password: {
        label: this.props.translate('confirmPassword'),
        elementType: 'input',
        elementConfig: {
          type: 'password',
          placeholder: this.props.translate('confirmPassword'),
          autoComplete: 'new-password'
        },
        value: '',
        validation: {
          required: true,
          shouldEqualTo: { value: '', fieldName: 'Password' }
        },
        valid: false,
        touched: false,
        error: null
      },
      roles: {
        label: this.props.translate('role'),
        elementType: 'newmultiSelect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('role'),
          options: [{ value: '0', label: 'Select Role' }]
        },
        value: [],
        validation: { required: false },
        valid: true,
        touched: false,
        error: null
      },
      is_ldap: {
        label: this.props.translate('ldap'),
        elementType: 'checkbox',
        elementConfig: {
          disabled: true
        },
        value: false,
        validation: { required: false },
        valid: true
      },
      is_active: {
        label: this.props.translate('active'),
        elementType: 'checkbox',
        value: true,
        validation: { required: false },
        valid: true
      }
    },
    filterControls: {
      role_id: {
        label: this.props.translate('role'),
        value: '',
        configs: {
          placeholder: 'Select Role',
          options: [{ value: '', label: 'Select Role' }]
        }
      },
      user_name: {
        label: this.props.translate('userName'),
        value: '',
        configs: {
          placeholder: 'Select User Name',
          options: [],
          disabled: true
        }
      },
      first_name: {
        label: this.props.translate('firstName'),
        value: '',
        configs: {
          placeholder: 'Select First Name',
          options: [],
          disabled: true
        }
      },
      last_name: {
        label: this.props.translate('lastName'),
        value: '',
        configs: {
          placeholder: this.props.translate('lastName'),
          options: [],
          disabled: true
        }
      },
      // is_ldap: {
      //   label: 'LDAP',
      //   value: '',
      //   configs: {
      //     placeholder: 'Select LDAP',
      //     options: [
      //       { value: 1, label: 'LDAP' },
      //       { value: 0, label: 'No LDAP' }
      //     ]
      //   }
      // },
      is_active: {
        label: this.props.translate('active'),
        value: '',
        configs: {
          placeholder: 'Select Active',
          options: [
            { value: 1, label: 'Active' },
            { value: 0, label: 'Inactive' }
          ]
        }
      }
    },
    addAno: false,
    updateProps: {
      selectedRecord: this.props.selectedRecord,
      roleOptions: this.props.roleOptions,
      filterUser: this.props.filterUser
    }
  }
  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.user_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.user_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'user_name', title: this.props.translate('userName'), type: 'string' },
    { field: 'first_name', title: this.props.translate('firstName'), type: 'string' },
    { field: 'last_name', title: this.props.translate('lastName'), type: 'string' },
    // {
    //   field: 'is_ldap',
    //   title: 'LDAP',
    //   render: rowData => {
    //     return <Checkbox checked={!!rowData.is_active} disabled />
    //   },
    //   width: 100
    // },
    {
      field: 'is_active',
      title: this.props.translate('active'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_active} disabled />
      },
      width: 150
    }
  ]
  componentDidMount() {
    this.props.fetchUser({ page: 1, perPage: 10 })
    this.props.fetchOptions()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state

    if (props.roleOptions !== updateProps.roleOptions) {
      const inputGroups = state.inputGroups
      const targetLevelItem = inputGroups.roles
      updatedState = {
        ...updatedState,
        inputGroups: updateObject(inputGroups, {
          roles: updateFormOptions(
            props.roleOptions,
            targetLevelItem,
            'role_id',
            'role_id',
            'role_name',
            'Select Role'
          )
        }),
        filterControls: updateObject(state.filterControls, {
          role_id: updateFilterOptions(
            props.roleOptions,
            state.filterControls.role_id,
            'role_id',
            'role_id',
            'role_name',
            null,
            null,
            state.filterControls.role_id.value
          )
        }),
        updateProps: {
          ...updateProps,
          roleOptions: props.roleOptions
        }
      }
    }
    if (props.filterUser !== updateProps.filterUser) {
      const setFilter = stateId => {
        let newFilter = updateFilterOptions(
          props.filterUser,
          state.filterControls[stateId],
          stateId,
          stateId,
          stateId,
          null,
          null,
          state.filterControls[stateId].value
        )
        newFilter = { ...newFilter, configs: { ...newFilter.configs, disabled: false } }
        return newFilter
      }
      updatedState = {
        ...updatedState,
        filterControls: updateObject(state.filterControls, {
          user_name: setFilter('user_name'),
          first_name: setFilter('first_name'),
          last_name: setFilter('last_name')
        }),
        updateProps: {
          ...updateProps,
          filterUser: props.filterUser
        }
      }
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let newUserData = Object.entries(state.inputGroups).reduce((userGroups, user) => {
        let [userKey, userAttrs] = user
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (userAttrs.elementType === 'checkbox') {
          value = false
          if (userKey === 'is_active') {
            value = true
          }
        }

        if (!userAttrs.validation || userAttrs.validation.required === false) {
          valid = true
        }

        if (state.action === 'edit' && ['password', 'confirm_password'].includes(userKey)) {
          valid = true
        }
        if (
          props.selectedRecord &&
          ![null, undefined, NaN].includes(props.selectedRecord[userKey])
        ) {
          value = props.selectedRecord[userKey]

          let { isValid, error } = checkValidity(value, userAttrs.validation, userAttrs.label)
          if (userAttrs.elementType === 'newmultiSelect') {
            value = value.map(dat => {
              return state.inputGroups[userKey].elementConfig.options.find(
                res => res.value === dat.role_id
              )
            })
          }
          if (userAttrs.elementType === 'checkbox') {
            value = !!value
          }
          valid = isValid
          errorMessage = error
        }

        let newLevelAttrs = {
          ...userAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return updateObject(userGroups, { [userKey]: { ...newLevelAttrs } })
      }, {})

      updatedState = {
        ...updatedState,
        inputGroups: newUserData,
        formValid: true,
        updateProps: {
          ...updateProps,
          selectedRecord: props.selectedRecord
        }
      }
    }
    return updatedState
  }

  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchUser(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchUser(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }

  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'roles':
          newFormAttrs = {
            ...formAttrs,
            value: []
          }
          break
        case 'is_ldap':
          newFormAttrs = {
            ...formAttrs,
            value: false
          }

          break
        case 'is_active':
          newFormAttrs = {
            ...formAttrs,
            value: true
          }
          break
        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})
    this.setState({ inputGroups: newFormData })
  }
  openModalHandler = (action, recordId) => {
    let { inputGroups } = this.state
    if (recordId && action === 'edit') {
      let { password, confirm_password } = inputGroups
      password = { ...password, validation: false }
      confirm_password = {
        ...confirm_password,
        validation: { ...confirm_password.validation, required: false }
      }
      this.setState(
        {
          action: action,
          actionRecordId: recordId,
          inputGroups: updateObject(inputGroups, { password, confirm_password })
        },
        () => {
          this.props.fetchUserById(recordId)
        }
      )
    } else {
      let { password, confirm_password } = inputGroups
      password = { ...password, validation: { ...password.validation, required: true } }
      confirm_password = {
        ...confirm_password,
        validation: { ...confirm_password.validation, required: true }
      }

      this.setState({
        action: action,
        actionRecordId: recordId,
        inputGroups: updateObject(inputGroups, { password, confirm_password })
      })
    }

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.openModal()
    }
  }

  openModal = () => {
    this.setState({
      modalOpen: true,
      formValid: false
    })
  }

  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false,
        formValid: false
      })
    }
  }
  clearModal = () => {
    this.props.clearSelectedRecord()
    this.clearInput()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        modalOpen: false
      })
    }
  }

  userSubmitHandler = type => {
    let userData = Object.entries(this.state.inputGroups).reduce((userData, userEntry) => {
      let [userKey, userAttrs] = userEntry
      let value = ''
      if (userAttrs.elementType === 'newmultiSelect') {
        value = userAttrs.value.map(res => {
          return res.value
        })
      } else {
        value = userAttrs.value
      }
      if (userKey === 'confirm_password') {
        return { ...userData }
      } else if (userKey === 'user_name') {
        return updateObject(userData, { [userKey]: value, emp_code: value })
      } else {
        return updateObject(userData, { [userKey]: value })
      }
    }, {})

    if (this.state.action === 'add') {
      this.props.createUser({ ...userData }, getPageStatus(this.props.pagination, false))
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateUser(
        this.state.actionRecordId,
        { ...userData },
        getPageStatus(this.props.pagination, false)
      )
    }

    this.setState({
      formValid: false
    })
  }

  inputChangeHandler = (userKey, event) => {
    const inputGroup = this.state.inputGroups
    const userItem = inputGroup[userKey]
    let inputValue = ''

    switch (userItem.elementType) {
      case 'newmultiSelect':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !userItem.value
        break
      default:
        inputValue = event.target.value
        break
    }
    const { isValid, error } = checkValidity(inputValue, userItem.validation, userItem.label)

    const updatedUserItem = {
      ...userItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }

    const updateGroup = updateObject(inputGroup, { [userKey]: updatedUserItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })

    if (userKey === 'password') {
      this.setState({
        inputGroups: updateObject(this.state.inputGroups, {
          [userKey]: updatedUserItem,
          confirm_password: {
            ...this.state.inputGroups.confirm_password,
            validation: {
              required: true,
              shouldEqualTo: { value: inputValue, fieldName: 'Password' }
            }
          }
        }),
        formValid: formIsValid
      })
    } else {
      this.setState({
        inputGroups: updateObject(this.state.inputGroups, { [userKey]: updatedUserItem }),
        formValid: formIsValid
      })
    }
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data
      let filter = filterControls[datakey]
      if (['user_name', 'first_name', 'last_name'].includes(datakey)) {
        filter = { ...filter, configs: { ...filter.configs, disabled: true } }
      }
      return (filterControls = updateObject(filterControls, {
        [datakey]: { ...filter, value: '' }
      }))
    })
    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      formValid: false,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId
    this.props.deleteUser(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    if (itemKey === 'role_id') {
      this.props.fetchFilter({ [itemKey]: filterValue?.value })
    }
    if (['user_name', 'first_name', 'last_name'].includes(itemKey)) {
      let { user_name, first_name, last_name } = this.state.filterControls

      let value = this.state.updateProps.filterUser.find(res => res[itemKey] === filterValue?.value)
      let userValue = user_name.configs.options.find(res => res.value === value?.user_name)
      let fnValue = first_name.configs.options.find(res => res.value === value?.first_name)
      let lnValue = last_name.configs.options.find(res => res.value === value?.last_name)
      this.setState({
        filterControls: updateObject(this.state.filterControls, {
          user_name: {
            ...user_name,
            value: userValue
          },
          first_name: {
            ...first_name,
            value: fnValue
          },
          last_name: {
            ...last_name,
            value: lnValue
          }
        }),
        filter: updateObject(this.state.filter, {
          user_name: userValue?.value,
          first_name: fnValue?.value,
          last_name: lnValue?.value
        })
      })
    } else {
      this.setState({
        filterControls: updateObject(this.state.filterControls, {
          [itemKey]: {
            ...filterItem,
            value: filterValue
          }
        }),
        filter: updateObject(this.state.filter, { [itemKey]: filterValue?.value })
      })
    }
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let param = { ...this.state.filter, page: 1, perPage: 10 }
    this.props.fetchUser(param)
    this.closeFilterModal()
  }

  render() {
    let userLabel = <Spinner />

    if (!this.props.loading) {
      userLabel = <Form form={this.state.inputGroups} inputChanged={this.inputChangeHandler} />
    }
    const footer = (
      <Footer
        save={() => this.userSubmitHandler('save')}
        another={() => this.userSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.clearModal()}
        disable={!validateForm(this.state.inputGroups)}
      />
    )
    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.userSubmitHandler}
    //         disabled={!this.state.formValid}>
    //         {this.props.translate('save')}
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         {this.props.translate('cancel')}
    //       </Button>
    //     </span>
    //   </div>
    // )

    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('users')}
          backdropClicked={this.closeModal}
          footer={footer}>
          <div className={classes.ModalBody}>{userLabel}</div>
        </Modal>
        <Card>
          <CardHeader className={classes.Header}>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('users')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loading}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.user.pagination,
    data: state.user.records,
    loading: state.user.loading,
    filterLoading: state.user.filterLoading,
    success: state.user.success,
    selectedRecord: state.user.selectedRecord,
    roleOptions: state.user.role,
    filterUser: state.user.filterUser
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchUser: filterOptions => dispatch(actions.fetchUser(filterOptions)),
    fetchUserById: recordId => dispatch(actions.fetchUserById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedUserRecord()),
    createUser: (recordData, page) => dispatch(actions.createUser(recordData, page)),
    updateUser: (recordId, recordData, page) =>
      dispatch(actions.updateUser(recordId, recordData, page)),
    deleteUser: (recordId, page) => dispatch(actions.deleteUser(recordId, page)),
    fetchOptions: () => dispatch(actions.fetchUserRoleOption()),
    fetchFilter: filter => dispatch(actions.fetchUserFilter(filter))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(SetupUser))
